import { Routes } from '@angular/router';
import { GenericErrorComponent } from './generic-error/generic-error.component';


export const routes: Routes = [
  {
    path: 'error',
    component: GenericErrorComponent
  }
];



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/shared.routes.ts